import SliderItemMember from "./SliderItemMember";
import Slider from "./Slider";
import DOMPurify from "dompurify";
function PricingBox(props){
    let items = props.items;
    return(<div className="tw-max-w-screen-lg tw-m-auto">
            <div className="tw-bg-gray-light tw-rounded-2xl tw-p-6 tw-pt-6">
                <div className="tw-text-black tw-text-center">
                <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 tw-mt-4 xmd:tw-leading-3 tw-mb-4">
                    {items.title[props.lang]}
                </h2>
                <p className="tw-mb-6 mb-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(items.description[props.lang]) }}/>
                </div>
                <Slider
                className="tw-pt-3 xmd:tw-hidden"
                viewportClassName="tw-overflow-visible"
                innerClassName="tw-space-x-2"
                // spacerClassName="w-3"
                >
                {items.items[props.lang].map((props, index) => {
                    return (
                    <SliderItemMember
                        className="tw-w-full" 
                        key={"slider_membership_" + index}
                        {...props}
                        lang={props.lang}
                    />
                    );
                })}
                </Slider>
                <div className="tw-hidden xmd:tw-flex xmd:tw-gap-2">
                {items.items[props.lang].map((props, index) => {
                    return (
                    <SliderItemMember
                        className="tw-flex-1"
                        key={"slider_membership_" + index}
                        {...props}
                        lang={props.lang}
                    />
                    );
                })}
                </div>
            </div>
        </div>);
}
export default PricingBox;